import React from "react";
import { Grid, makeStyles } from "@material-ui/core";

import CampaignTableDetails from "./Campaign";
import ScalingOverview from "./ScalingOverview";
import ScalingTimeline from "./ScalingTimeline";

export default function CardDetails(props) {
  const { tableWidth, campaign, language_name } = props;

  const useStyles = makeStyles((theme) => ({
    tableWrapper: {
      border: 0,
      borderRight:
        tableWidth === "100%" ? 0 : `1px solid ${theme.palette.text.disabled}`,
      width: tableWidth,
    },
  }));
  const classes = useStyles();

  // Variable: Set Mode If Is Editing
  const edit_mode = tableWidth === "100%";

  return (
    <Grid item className={classes.tableWrapper}>
      <CampaignTableDetails
        tableWidth={tableWidth}
        campaign={campaign}
        language_name={language_name}
      />
      {!edit_mode && (
        <>
          <ScalingOverview campaign={campaign} />{" "}
          <ScalingTimeline campaign={campaign} />{" "}
        </>
      )}{" "}
    </Grid>
  );
}
